module.exports = __webpack_public_path__ + "img/message1.77f58118.svg";